module.exports = __webpack_public_path__ + "static/media/marker_scissors.5fcae6d6.svg";